import Vue from "@/main";
import { connection } from "./jsstore_con";

export class CustomerChatReactionsService {
    constructor() {
        this.tableName = "CustomerChatReactions";
    }

    async insert(value, refresh = false, socket = false) {
        let inserted = await connection.insert({
            into: this.tableName,
            values: value,
            upsert: true
        });

        if (inserted > 0 && refresh && socket) {
            Vue.$events.fire('RefreshObserverChatData', value[0]);
            Vue.$events.fire('RefreshQueryObservable', false);
        }
    }
    
    async update(value, refresh = false, socket = false) {
        value = value[0];
        let updated = await connection.update({
            in: this.tableName,
            set: {
                ack: Number(value.ack),
                sent_at: value.sent_at,
                type: Number(value.type),
                reaction_text: value.reaction_text
            },
            where: {
                id: value.id
            }
        });

        if (updated > 0 && refresh && socket) {
            Vue.$events.fire('RefreshObserverChatData', value);
            Vue.$events.fire('RefreshQueryObservable', false);
        }
    }

    async remove(value, refresh = false, socket = false) {
        value = value[0];
        const removed = await connection.remove({
            from: this.tableName,
            where: { id: value.id }
        });

        if (removed > 0 && refresh && socket) {
            Vue.$events.fire('RefreshObserverChatData', value);
            Vue.$events.fire('RefreshQueryObservable', false);
        }
    }

    async getByWhere(where){
        return await connection.select({
            from: 'CustomerChatReactions',
            where: where,
            order: [
                {
                    by: 'type',
                    type: 'asc',
                    idbSorting: false
                }
            ],
        });
    }

    async getById(value) {
        return await connection.select({
            from: this.tableName,
            where: { id: value }
        })
    }

    async clearTable(instanceIds, ticketIds = []) {
        const where =  ticketIds && ticketIds.length > 0 ? { chat_ticket_id: { in: ticketIds }} : { instance_id: { in: instanceIds }};
        const customerChat = await connection.select( {
            from: 'CustomerChats',
            where: where
        });

        if ( customerChat.length > 0 ) {
            const ids = customerChat.map((cChat) => { return cChat.id; })
            await connection.remove({
                from: this.tableName,
                where: { customer_chat_id: { in: ids }}
            })
        }
    }
}
